<template>
  <svg
    class="sol-page-loader-page"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"></svg>
</template>

<style lang="scss">
  .sol-page-loader-page {
    @apply stroke-2;
    @apply mx-auto;
    background: rgba(#fff, 0.9)
      url(https://cdn.solfacil.com.br/assets/img/loading-for-legacy.gif)
      no-repeat center center;

    .path {
      @apply stroke-feedback-informative-pure;
      @apply stroke-cap-round origin-center;

      stroke-dashoffset: -10;
      animation: dash 1.2s ease-out infinite;

      &.-dark {
        @apply stroke-neutral-high-pure;
      }
    }
  }
</style>
